import { render, staticRenderFns } from "./c-logedit.vue?vue&type=template&id=ab0fa740&scoped=true"
import script from "./c-logedit.vue?vue&type=script&lang=js"
export * from "./c-logedit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0fa740",
  null
  
)

export default component.exports